import { ValidatorFn } from '@angular/forms';

const ZIPCODE_REGEX = /^[0-9]{7}$/;

let timeoutId: number | null = null;

export const zipcodeValidator: (
  callback: () => void | Promise<void>
) => ValidatorFn = (callback) => {
  // WORKAROUND: onInputの動作がモバイル環境では不確定。
  // onChangeはフォーカスを外す必要があり、モバイルでは都道府県選択をタップしてしまい住所の自動入力に気が付かない恐れがある。
  // 回避策として、最後のバリデーション通過時に自動入力を実行するように修正。
  return (control) => {
    if (typeof timeoutId === 'number') {
      clearTimeout(timeoutId);
    }

    const value = control.value;
    if (typeof value !== 'string') {
      return { invalidType: 'zipcode入力を行ってください。' };
    }
    if (!ZIPCODE_REGEX.test(value)) {
      return { invalidMail: '郵便番号を正しく入力してください。' };
    }
    if (control.dirty || control.touched) {
      timeoutId = window.setTimeout(callback, 500);
    }
    return null;
  };
};
